module.exports = __webpack_public_path__ + "img/logo-header@2x.1e3bb0c.png";